module.exports = __webpack_public_path__ + "img/12.749f50b0.png";